import React from 'react';
import * as S from '../sipstyles/SipClient.style';
import { FaPhone } from 'react-icons/fa';

interface StatusDisplayProps {
  callTime: string;
  phoneNumber: string;
  incomingCallInfo: { caller: string } | null;
  callStatus: 'idle' | 'dialing' | 'connected' | 'ended' | 'ringing';
}

const StatusDisplay = ({ callTime, phoneNumber, incomingCallInfo, callStatus }: StatusDisplayProps) => {
  return (
    <S.StatusDisplay>
      <S.CallTime>
        {callStatus === 'ended' && '통화종료...'}
        {callStatus === 'ringing' && (
          <div>
            <FaPhone />
            <span>수신중...</span>
          </div>
        )}
        {callStatus !== 'ended' && callStatus !== 'ringing' && callTime}
      </S.CallTime>
      <h2>
        {(callStatus === 'dialing' || (!incomingCallInfo && callStatus === 'connected')) && phoneNumber}
        {(callStatus === 'ringing' || (incomingCallInfo && callStatus === 'connected')) &&
          (incomingCallInfo?.caller ? incomingCallInfo.caller : '알 수 없음')}
      </h2>
    </S.StatusDisplay>
  );
};

export default StatusDisplay;
